<template>
   <div class="card-header">
      <div class='group-title-wrapper'>
         <svg-icon color="#333" size="large" :url="category.icon_url"/>
         <span> {{ category.title }}</span>
      </div>
      <input
         type="checkbox"
         @click.stop="event => $emit('toggle-all-layers', event.target.checked)"
         :checked="allLayersAreVisible"
      />
   </div>
</template>

<script>
import SvgIcon from '../../../atoms/Home/SvgIcon';

export default {
   name: 'layer-group-header',
   components: {
      SvgIcon,
   },
   props: {
      allLayersAreVisible: {
         type: Boolean,
         required: true,
      },
      category: {
         type: Object,
         required: true,
      },
   },
}
</script>

<style lang="scss" scoped>
.card-header {
   height: 100%;
   width: 100%;
   display: flex;
   justify-content: space-between;
   align-items: center;
   
   .group-title-wrapper {
      display: flex;
      align-items: center;

      > *:first-child {
         margin-right: 4px;
      }

      span {
         font-weight: 400;
         font-size: 16px;
         color: darken($font-color, 10%);
         text-transform: uppercase;
         font-family: $secondary-font;
      }
   }
}

</style>